<template>
   <main class="bg-white">
    <nav class="navbar navbar-dark bg-dark">
        <a class="navbar-brand">
          Instructions
        </a>
      </nav>
    <div class="container">
      <router-view/>
    </div>
  </main>
</template>

<script>
export default {

}
</script>